import { Link } from "react-router-dom";
import { Star, MapPin, Users, Trophy, ShieldCheck, ArrowRight } from "lucide-react";

export const DEFAULT_BANNERS = {
  coaching: "https://images.pexels.com/photos/7972378/pexels-photo-7972378.jpeg?auto=compress&cs=tinysrgb&w=800",
  school: "https://images.pexels.com/photos/8423433/pexels-photo-8423433.jpeg?auto=compress&cs=tinysrgb&w=800",
  college: "https://images.pexels.com/photos/207692/pexels-photo-207692.jpeg?auto=compress&cs=tinysrgb&w=800",
};
export const TYPE_LABEL = { coaching: "Coaching", school: "School", college: "College" };

export const bannerFor = (inst) => inst.banner_url || DEFAULT_BANNERS[inst.type] || DEFAULT_BANNERS.coaching;

export const ListingCard = ({ inst, index = 0, leader = false }) => {
  const featured = inst.badge === "featured";
  return (
    <Link
      to={`/institutes/${inst.id}`}
      data-testid={`listing-card-${inst.id}`}
      className={`listing-card group block overflow-hidden fade-up ${leader ? "listing-leader" : ""}`}
      style={{
        animationDelay: `${Math.min(index * 60, 400)}ms`,
        border: `2px solid ${featured ? "#EAB308" : "#171B33"}`,
        borderRadius: 18,
        background: "#fff",
        boxShadow: `4px 4px 0 ${featured ? "#EAB308" : "#171B33"}`,
      }}
    >
      <div className="listing-image relative h-44 overflow-hidden border-b-2 border-[#171B33]">
        <img src={bannerFor(inst)} alt={inst.name} className="w-full h-full object-cover" />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="nb-badge" style={{ background: "#A3E635" }}>{leader ? <><Trophy className="w-3 h-3" /> Rank #{index + 1}</> : TYPE_LABEL[inst.type] || "Coaching"}</span>
          {featured && <span data-testid="badge-featured" className="nb-badge" style={{ background: "#FCD34D" }}>★ Featured</span>}
        </div>
        <div className="absolute top-3 right-3 flex flex-col items-end gap-2">
          <span className="nb-badge" style={{ background: "#FB923C" }}><Trophy className="w-3 h-3" /> {Math.round(inst.total_score)} pts</span>
          {inst.badge === "verified" && <span data-testid="badge-verified" className="nb-badge" style={{ background: "#93C5FD" }}><ShieldCheck className="w-3 h-3" /> Verified</span>}
        </div>
        <div className="listing-image-footer md:hidden"><span>{inst.school_info?.board || (inst.exams || []).slice(0, 2).join(" · ") || TYPE_LABEL[inst.type]}</span><span><Star size={12} />{inst.avg_rating || "New"} · <Users size={12} />{inst.admissions || 0} Enrolled</span></div>
      </div>
      <div className="listing-body p-5">
        <h3 className="font-display text-lg font-extrabold tracking-tight group-hover:text-lime-600 transition-colors duration-150">{inst.name}</h3>
        <div className="flex items-center gap-3 text-sm text-slate-600 mt-1.5 flex-wrap">
          <span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {inst.area}</span>
          <span className="flex items-center gap-1"><Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" /> {inst.avg_rating || "—"}</span>
          <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {inst.admissions || 0}+</span>
        </div>
        {inst.description && <p className="text-sm text-slate-500 mt-2 line-clamp-2">{inst.description}</p>}
        <div className="listing-mobile-tags md:hidden">{(inst.exams || []).slice(0, 4).map((exam) => <span key={exam}>{exam}</span>)}</div>
        <span className="listing-mobile-cta md:hidden" data-testid={`listing-action-${inst.id}`}>{inst.type === "school" ? "View Profile & Fees" : "View Details"}<ArrowRight size={14} /></span>
      </div>
    </Link>
  );
};

export default ListingCard;
